import React from "react";

type Props = {
  open: boolean;
  onUseCurrent: () => void;
  onKeepSaved: () => void;
  onClose: () => void;
  autoOnLogin?: boolean;
  onToggleAuto?: (next: boolean) => void;
};

export default function LocationConfirmModal({
  open,
  onUseCurrent,
  onKeepSaved,
  onClose,
  autoOnLogin = false,
  onToggleAuto,
}: Props) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100]">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />

      {/* Centered modal */}
      <div
        role="dialog"
        aria-modal="true"
        className="relative z-[101] mx-auto w-[min(680px,95vw)]"
        style={{ top: "50%", transform: "translateY(-50%)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="overflow-hidden rounded-2xl border border-slate-800 bg-gray-950 text-white shadow-2xl">
          {/* Body: 2 columns on md+ */}
          <div className="grid grid-cols-1 md:grid-cols-[240px,1fr]">
            {/* Left: Goblin image centered */}
            <div className="bg-black/30 border-b md:border-b-0 md:border-r border-slate-800 p-4 grid place-items-center">
              <img
                src="/images/lost-goblin.png"
                alt="Spellgather goblin"
                className="block max-h-44 max-w-[200px] object-contain"
                onError={(e) => ((e.currentTarget as HTMLImageElement).style.display = "none")}
              />
            </div>

            {/* Right: Text + controls */}
            <div className="p-5">
              <div className="mb-2">
                <div className="text-lg font-semibold">Use your current location?</div>
                <div className="text-slate-300 text-sm">
                  We can use your device location at sign-in to keep play and trade matches fresh.
                </div>
              </div>

              <label className="mt-3 mb-4 flex items-center gap-2 text-sm text-slate-200">
                <input
                  type="checkbox"
                  className="h-4 w-4 accent-amber-500"
                  checked={!!autoOnLogin}
                  onChange={(e) => onToggleAuto?.(e.target.checked)}
                />
                Remember this preference for next time
              </label>

              <div className="mt-1 flex items-center justify-end gap-2">
                <button
                  type="button"
                  className="px-3 py-2 rounded border border-slate-700 hover:bg-white/5"
                  onClick={onKeepSaved}
                >
                  Keep saved
                </button>
                <button
                  type="button"
                  className="px-3 py-2 rounded bg-amber-500 text-black hover:bg-amber-400"
                  onClick={onUseCurrent}
                >
                  Use current location
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
